import React, { Component } from "react";
import { Table, Button, Col, Row } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";

const { Column } = Table;

class OrdemServicoAvulsosPrintModal extends Component {
    state = {
        listaRegistros: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if (!stateAnte.visualizar && this.state.visualizar) {
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });

        const { buscaDataIni, buscaDataFim, buscaControle, buscaPessoa, buscaUsuario, buscaServico } = this.props.filtros;

        let dataIni = '';
        if ((buscaDataIni) && (buscaDataIni !== undefined)) {
            dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }
        let dataFim = '';
        if ((buscaDataFim) && (buscaDataFim !== undefined)) {
            dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }

        axios
            .get('/ordem_servicos/avulsosOS', {
                params: {
                    print: true,
                    numero: buscaControle,
                    pessoa: buscaPessoa.key,
                    usuario: buscaUsuario.key,
                    servico: buscaServico.key,
                    dataIni,
                    dataFim,
                }
            })
            .then(response => {
                const { data } = response;
                this.setState({
                    listaRegistros: data.dados,
                    carregando: false,
                });
            })
            .catch(erro => {
                console.warn(erro);
                this.setState({
                    carregando: false,
                });
            });
    };

    onCancelar = () => {
        this.setState({
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (vlr, registro) => {
        return (
            <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
        );
    };

    renderValorCusto = (vlr, registro) => {
        return (
            <span> {numeral(parseFloat(vlr * registro.osia_qtde)).format('0,000.00')} </span>
        );
    };

    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY HH:mm')}
                </span>
            )
        } else {
            <span></span>
        }
    }

    renderSitOS = (sit) => {
        return (
            <span> {sit === 'ESP' ? 'ESPERA' : (sit === 'AGE' ? 'AGENDADO' : (sit === 'EXE' ? 'EXECUÇÃO' : (sit === 'FIN' ? 'FINALIZADA' : (sit === 'ENT' ? 'ENTREGUE' : ''))))} </span>
        );
    };

    renderSitFinanc = (sit) => {
        return (
            <span> {sit === 'P' ? 'PAGO' : 'ABERTO'} </span>
        );
    };


    render() {
        const { listaRegistros, carregando, visualizar } = this.state;
        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModal
                    visible={visualizar}
                    onCancel={this.onCancelar}
                >
                    <div >
                        <div className="titulo">
                            Itens Avulsos
                        </div>

                        <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 20, textAlign: "right" }} >
                                <span style={{ fontWeight: "bold" }}>Qtde Serviços: </span>
                                <span>{this.props.qtdeOS}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 50 }}>Total Custo: </span>
                                <span>R$ {this.renderValor(this.props.totalCusto)}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 50 }}>Total Venda: </span>
                                <span>R$ {this.renderValor(this.props.totalOS)}</span>
                            </Col>
                        </Row>

                        <Table
                            pagination={false}
                            dataSource={listaRegistros}
                            className="tabela"
                            rowKey={(listaRegistros => listaRegistros.os_idf)}
                            loading={{
                                spinning: carregando,
                                tip: 'Carregando. Aguarde...',
                                size: "large"
                            }}
                        >
                            <Column
                                key="os_numero"
                                dataIndex="os_numero"
                                title="Número"
                                width={90}
                                align="center"
                                className="listaCadastro"
                            />
                            <Column
                                key="os_data_emissao"
                                dataIndex="os_data_emissao"
                                title="Data"
                                render={this.renderData}
                                width={150}
                                align="center"
                                className="listaCadastro"
                            />
                            <Column
                                key="pes_nome"
                                dataIndex="pes_nome"
                                title="Cliente"
                                width={200}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="os_descricao"
                                dataIndex="os_descricao"
                                title="Descrição"
                                width={100}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="os_situacao"
                                dataIndex="os_situacao"
                                title="Situação"
                                render={this.renderSitOS}
                                width={100}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="osia_descricao"
                                dataIndex="osia_descricao"
                                title="Item Avulso"
                                width={120}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="osia_qtde"
                                dataIndex="osia_qtde"
                                title="Qtde"
                                render={this.renderValor}
                                width={90}
                                align="right"
                                className="listaCadastro"
                            />
                            <Column
                                key="osia_custo_unit"
                                dataIndex="osia_custo_unit"
                                title="Custo Unit"
                                render={this.renderValor}
                                width={90}
                                align="right"
                                className="listaCadastro"
                            />
                            <Column
                                key="osia_custo_unit"
                                dataIndex="osia_custo_unit"
                                title="Total Custo"
                                render={this.renderValorCusto}
                                width={90}
                                align="right"
                                className="listaCadastro"
                            />
                            <Column
                                key="osia_vlr_unit"
                                dataIndex="osia_vlr_unit"
                                title="Vlr Venda"
                                render={this.renderValor}
                                width={90}
                                align="right"
                                className="listaCadastro"
                            />
                            <Column
                                key="osia_vlr_total"
                                dataIndex="osia_vlr_total"
                                title="Total Venda"
                                render={this.renderValor}
                                width={90}
                                align="right"
                                className="listaCadastro"
                            />
                        </Table>
                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default OrdemServicoAvulsosPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/OrdemServicoAvulsosPrintModal.js